import { TranslationObject } from '@ngx-translate/core';
import { FactMetadata } from '@lib.core/entities/indicator/fact-metadata';

export class FactMetadataDTO {
  factNameid!: string;
  title!: TranslationObject;
  description!: TranslationObject;
  unit!: string;
  isFactOfInterest?: boolean; // Denotes if the fact should determine the bubble size in a multi-fact aspect
  availableGeoTypes?: string[];

  static toFactMetadata(factMetadataDTO: FactMetadataDTO): FactMetadata {
    const { factNameid, title, description, unit, isFactOfInterest, availableGeoTypes } = factMetadataDTO;
    return new FactMetadata(factNameid, title, description, unit, isFactOfInterest, availableGeoTypes);
  }
}
